import { FC, useEffect, useState } from "react";
import TabsContentHeader from "../../components/AdminDashboardTabsContentHeader/TabsContentHeader";
import { Students } from "./AdminStudents";
import images from "../../assets/images";
import './AdminStudents.scss'
import { useLazyQuery } from "@apollo/client";
import { GET_STUDENTS_BY_ID } from "./api/AdminStudentsQuery";
import ToasterWithMessage from "../../components/toaster";
import Loader from "../../components/Loader/Loader";
import StudentProfileForm from "../../components/StudentProfileForm/StudentProfileForm";
import { FETCH_POLICY } from "../../utils/constants";

interface propsType {
    displayStudentForm: boolean;
    setDisplayStudentForm: (val: boolean) => void;
    studentData: Students | undefined;
}

const EditStudentProfile:FC<propsType> = ({ studentData, setDisplayStudentForm, displayStudentForm }) => {

    const { backArrow } = images;
    const [searchValue, setSearchValue] = useState<string>("");
    const [student, setStudent] = useState<Students>();
    const { error } = ToasterWithMessage();

    const [getStudentById, { loading }] = useLazyQuery(GET_STUDENTS_BY_ID, {
        fetchPolicy: FETCH_POLICY,
        onCompleted: (data) => {
            setStudent(data?.studentBySId);
        },
        onError: (err) => {
            error(err?.message);
        }
    })

    useEffect(() => {
        getStudentById({
            variables: {
                sId: studentData?.sId
            }
        })
    }, [studentData])
    
    return (
        <div className="EditStudentProfile">
            <TabsContentHeader
                title={studentData?.userByUId?.uFullName ? studentData?.userByUId?.uFullName : '-'}
                subtitle={"Edit Profile image and Student detail"}
                addLabel={""}
                setDisplayForm={setDisplayStudentForm}
                displayForm={displayStudentForm}
                subImage={backArrow} 
                searchValue={searchValue}
                setSearchValue={setSearchValue}
            />
            {(loading || !student) ? <Loader bottom="120px"/> : (
                <StudentProfileForm 
                    id={student?.sId}
                    fullName={student?.userByUId?.uFullName}
                    username={student?.userByUId?.uUserName}
                    password={student?.userByUId?.uUserPassword}
                    phonenumber={student?.userByUId?.uPhoneNumber}
                    email={student?.userByUId?.uEmailId} 
                    avatarUrl={student?.sAvatarUrl} 
                    isEdit={true}
                    displayForm={displayStudentForm}
                    setDisplayForm={setDisplayStudentForm}
                />
            )}
        </div>
    );
}

export default EditStudentProfile;